import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@1trading/react';
import { Calculator } from 'lucide-react';
import { useState } from 'react';
import { FuturesAssessmentExplanationDialog } from './futures-assessment-explanation-dialog';
import { StructuredAnswers } from './structured-answers';

interface ExplainableFuturesAnswersProps {
  answers: unknown;
  pid: string;
  /** The attempt's stored date, exactly as saved */
  date: string;
  title: string;
  isV1?: boolean;
}

export const ExplainableFuturesAnswers = ({ answers, pid, date, title, isV1 = false }: ExplainableFuturesAnswersProps) => {
  const [isExplaining, setIsExplaining] = useState(false);

  return (
    <div className="flex flex-col items-start gap-3">
      <div className="w-full">
        <StructuredAnswers value={answers} />
      </div>
      {isV1 ? (
        <Tooltip>
          <TooltipTrigger asChild>
            {/* aria-disabled rather than disabled, so the button still takes hover and focus for the tooltip */}
            <Button aria-disabled className="cursor-not-allowed gap-1.5 opacity-50" size="sm" type="button" variant="outline">
              <Calculator className="size-3.5" />
              Explain score
            </Button>
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">
            Not available for v1 attempts: v1's scoring changed in May–June 2025, after they were scored, so a breakdown wouldn't match the stored result.
          </TooltipContent>
        </Tooltip>
      ) : (
        <Button className="gap-1.5" onClick={() => setIsExplaining(true)} size="sm" type="button" variant="outline">
          <Calculator className="size-3.5" />
          Explain score
        </Button>
      )}
      {isExplaining ? <FuturesAssessmentExplanationDialog date={date} onClose={() => setIsExplaining(false)} pid={pid} title={title} /> : null}
    </div>
  );
};
ExplainableFuturesAnswers.displayName = 'ExplainableFuturesAnswers';
